module.exports = __webpack_public_path__ + "static/gallery_04-thumb-162b0a512c9ec4527a7653cd7330dada.jpg";